{
  "close": "Fechar"
}
